/* N.B. These codes need to reflect app/src/Entity/ConsultantTicketType.php in the api project */
const CONSULTANT_TICKET_TYPE_CODES = {
  BANK_CHANGE: 'BNK',
  FEE_CHANGE: 'FEE',
  HOLIDAY: 'HOL',
  OTHER: 'OTH',
  FEE_CONFIRMATION: 'FCF',
  INSURANCE_RECOGNITION: 'INS',
  CONSULTANT_BROADCAST: 'CBC',
  LEAVING: 'LEA',
  PATIENT_QUERY: 'PTQ',
  MONTHLY_REPORT_QUERY: 'MRQ',
};

export default CONSULTANT_TICKET_TYPE_CODES;
